import {Component, Input} from '@angular/core';
import {Location} from '@angular/common';


@Component({
    selector: 'page-loader',
    templateUrl: "./loader.component.html"
})
export class PageLoader {

    @Input()
    public isShown: boolean = true;

    constructor() {
        this.isShown = false;
    }

    show(){
        this.isShown = true;
    }

    hide(){
        this.isShown = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/loader/loader.component.ts